import { render, staticRenderFns } from "./AnnotationHistogram.vue?vue&type=template&id=5c3fc6b5&lang=pug"
import script from "./AnnotationHistogram.vue?vue&type=script&lang=js"
export * from "./AnnotationHistogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports